import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../button/Button.jsx';

import s from './FailedSavesMenu.module.scss';

const failedSavesMenu = ({ failedPois, onSelectPoi, className, onCancel, onRetry }) => {
    const allString = failedPois.length > 1 ? ' ALL' : '';
    return (
        <div className={classNames(s.failedSavesMenu)}>
            <div className={s.backdrop} onClick={() => onSelectPoi()} />
            <div className={classNames(s.menu, className)}>
                {failedPois.map(poi => (
                    <div className={s.poiRow} key={poi.id} onClick={() => onSelectPoi(poi.id)}>
                        <div className={s.idLine}>POI ID: {poi.id}</div>
                        <div className={s.nameLine}>{poi.name}</div>
                    </div>
                ))}
                <div className={s.buttons}>
                    <Button little flat color="clear" className={s.cancel} onClick={onCancel} label={`CANCEL${allString}`} />
                    <Button little flat className={s.retry} onClick={onRetry} label={`RETRY${allString}`} />
                </div>
            </div>
        </div>
    );
};

failedSavesMenu.propTypes = {
    failedPois: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            id: PropTypes.string,
        }),
    ),
    onSelectPoi: PropTypes.func,
    className: PropTypes.string,
    onCancel: PropTypes.func,
    onRetry: PropTypes.func,
};

failedSavesMenu.defaultProps = {
    failedPois: [],
    onSelectPoi: () => {},
    onCancel: () => {},
    onRetry: () => {},
};

export default failedSavesMenu;
